/* UltraClean Pro — DA « 40 000 » : moteur d'interactions de la page d'accueil.
   Dépend de uc-gsap.min.js, uc-scrolltrigger.min.js et uc2-lenis.min.js
   (chargés en defer avant ce fichier). Tout se dégrade proprement sans eux. */
(function () {
  'use strict';

  var html = document.documentElement;
  if (!html.classList.contains('uc2')) return;

  var rm = false; /* forcé — effets cinétiques toujours actifs, ignore le réglage OS (choix du site) */
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var desktop = window.matchMedia('(min-width: 900px)');
  var gsap = window.gsap;
  var ST = window.ScrollTrigger;
  var hasGsap = !!(gsap && ST);
  var lenis = null;

  if (!hasGsap) {
    html.classList.remove('uc2-js', 'uc2-intro');
    return;
  }
  gsap.registerPlugin(ST);
  ST.defaults({ scroller: window });

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var lerp = function (a, b, n) { return a + (b - a) * n; };

  /* ------------------------------------------------------------- smooth scroll */
  if (!rm && window.Lenis) {
    lenis = new window.Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.95 });
    lenis.on('scroll', ST.update);
    gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
    gsap.ticker.lagSmoothing(0);
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href^="#"]');
    if (!a) return;
    var id = a.getAttribute('href');
    if (id.length < 2) return;
    var target = document.querySelector(id);
    if (!target) return;
    e.preventDefault();
    closeSheet();
    if (lenis) lenis.scrollTo(target, { offset: 0, duration: 1.6 });
    else target.scrollIntoView({ behavior: rm ? 'auto' : 'smooth' });
  });

  /* ------------------------------------------------------------------- split */
  function splitChars(el) {
    var txt = el.textContent;
    el.textContent = '';
    for (var i = 0; i < txt.length; i++) {
      var s = document.createElement('span');
      s.className = 'uc2-char';
      s.textContent = txt[i] === ' ' ? ' ' : txt[i];
      el.appendChild(s);
    }
    return $$('.uc2-char', el);
  }

  function splitLines(el) {
    if (el.dataset.uc2Split) return $$('.uc2-line > span', el);
    el.dataset.uc2Split = '1';
    var parts = el.innerHTML.split(/<br\s*\/?>/i);
    el.innerHTML = parts.map(function (p) {
      return '<span class="uc2-line"><span>' + p + '</span></span>';
    }).join('');
    return $$('.uc2-line > span', el);
  }

  /* ----------------------------------------------------------------- loader */
  var heroTitle = $('[data-uc2-hero-title]');
  var heroChars = heroTitle ? $$('[data-uc2-chars]', heroTitle).map(splitChars) : [];
  var heroFades = $$('[data-uc2-hero-fade]');

  // « implose. » : la dernière lettre pleine, le reste en contour
  if (heroChars[1] && heroChars[1].length) heroChars[1][heroChars[1].length - 1].classList.add('is-hot');

  function heroIntro(delay) {
    var tl = gsap.timeline({ delay: delay || 0 });
    if (!heroChars.length && !heroFades.length) return tl;
    heroChars.forEach(function (chars, i) {
      tl.to(chars, { yPercent: 0, duration: 1.3, ease: 'expo.out', stagger: 0.035 }, i * 0.12);
    });
    tl.to(heroFades, { opacity: 1, y: 0, duration: 1.1, ease: 'expo.out', stagger: 0.08 }, 0.35);
    return tl;
  }
  // les caractères partent de translateY(105%) en CSS
  heroChars.forEach(function (chars) { gsap.set(chars, { yPercent: 105, y: 0 }); });

  if (rm) {
    gsap.set(heroChars.flat ? heroChars.flat() : [], { yPercent: 0 });
    gsap.set(heroFades, { opacity: 1, y: 0 });
    html.classList.remove('uc2-intro');
  } else if (html.classList.contains('uc2-intro')) {
    if (lenis) lenis.stop();
    var loader = $('.uc2-loader');
    var num = $('[data-uc2-loader-num]');
    var o = { v: 0 };
    gsap.timeline()
      .to(o, { v: 40, duration: 1.4, ease: 'power3.inOut', onUpdate: function () { num.textContent = String(Math.round(o.v)).padStart(2, '0'); } })
      .to('.uc2-loader__bar', { scaleX: 1, duration: 1.4, ease: 'power3.inOut' }, 0)
      .to(loader, { clipPath: 'inset(0 0 100% 0)', duration: 1, ease: 'expo.inOut' }, '+=0.15')
      .add(function () {
        try { sessionStorage.setItem('uc2-intro', '1'); } catch (e) {}
        if (lenis) lenis.start();
        heroIntro(0);
      }, '-=0.55')
      .add(function () { html.classList.remove('uc2-intro'); });
  } else {
    heroIntro(0.1);
  }

  /* ------------------------------------------------------------ cycles live */
  var cyclesEl = $('[data-uc2-cycles]');
  if (cyclesEl) {
    var t0 = performance.now();
    var fmt = new Intl.NumberFormat('fr-FR');
    (function tick() {
      cyclesEl.textContent = fmt.format(Math.floor((performance.now() - t0) * 40));
      requestAnimationFrame(tick);
    })();
  }

  /* ------------------------------------------------------------ hero shader */
  (function shader() {
    var canvas = $('[data-uc2-gl]');
    if (!canvas) return;
    var gl = canvas.getContext('webgl', { antialias: false, alpha: false, powerPreference: 'high-performance' });
    if (!gl) { canvas.remove(); return; }

    var vs = 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}';
    var fs = [
      'precision highp float;',
      'uniform vec2 r;uniform float t;uniform vec2 m;uniform float mi;',
      'float h(vec2 p){return fract(sin(dot(p,vec2(127.1,311.7)))*43758.5453);}',
      'void main(){',
      '  vec2 uv=gl_FragCoord.xy/r;',
      '  vec2 p=(gl_FragCoord.xy-.5*r)/r.y;',
      '  float asp=r.x/r.y;',
      '  float w=0.;',
      '  for(int i=0;i<6;i++){',
      '    float fi=float(i);',
      '    vec2 s=vec2((fi/5.-.5)*asp*.95,-.62+.03*sin(t*.7+fi));',
      '    float d=length(p-s);',
      '    w+=sin(d*34.-t*2.6+fi*1.7)/(1.+d*1.6);',
      '  }',
      '  vec2 mp=(m-.5*r)/r.y;',
      '  float dm=length(p-mp);',
      '  w+=mi*2.2*sin(dm*60.-t*7.)*exp(-dm*3.);',
      '  float aw=abs(w);',
      '  float glow=pow(clamp(aw/3.2,0.,1.),2.2);',
      '  float iso=abs(fract(w*.75)-.5);',
      '  float line=smoothstep(.07,.0,iso)*smoothstep(.2,1.4,aw);',
      '  vec2 g=floor(gl_FragCoord.xy/3.);',
      '  float bub=step(.992-.03*clamp(aw-1.6,0.,1.),h(g+floor(t*18.)))*smoothstep(1.4,2.6,aw);',
      '  vec3 blue=vec3(.18,.36,1.);',
      '  vec3 col=blue*(glow*.9+line*.35)+vec3(.78,.86,1.)*bub;',
      '  float fade=mix(1.,.28,smoothstep(.15,.95,uv.y));',
      '  col*=fade;',
      '  col*=smoothstep(1.35,.35,length((uv-.5)*vec2(1.,1.3)));',
      '  gl_FragColor=vec4(col,1.);',
      '}'
    ].join('\n');

    function compile(type, src) {
      var s = gl.createShader(type);
      gl.shaderSource(s, src);
      gl.compileShader(s);
      return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
    }
    var v = compile(gl.VERTEX_SHADER, vs);
    var f = compile(gl.FRAGMENT_SHADER, fs);
    if (!v || !f) { canvas.remove(); return; }
    var prog = gl.createProgram();
    gl.attachShader(prog, v);
    gl.attachShader(prog, f);
    gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) { canvas.remove(); return; }
    gl.useProgram(prog);

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
    var loc = gl.getAttribLocation(prog, 'a');
    gl.enableVertexAttribArray(loc);
    gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

    var uR = gl.getUniformLocation(prog, 'r');
    var uT = gl.getUniformLocation(prog, 't');
    var uM = gl.getUniformLocation(prog, 'm');
    var uMi = gl.getUniformLocation(prog, 'mi');

    var scale = window.innerWidth < 900 ? 0.45 : 0.6;
    var W = 0, H = 0;
    function resize() {
      var rect = canvas.getBoundingClientRect();
      W = Math.max(1, Math.round(rect.width * scale));
      H = Math.max(1, Math.round(rect.height * scale));
      canvas.width = W;
      canvas.height = H;
      gl.viewport(0, 0, W, H);
    }
    resize();
    window.addEventListener('resize', resize);

    var mouse = { x: W * 0.62, y: H * 0.35, tx: W * 0.62, ty: H * 0.35, i: 0, ti: 0 };
    var hero = canvas.parentElement;
    hero.addEventListener('pointermove', function (e) {
      var rect = canvas.getBoundingClientRect();
      mouse.tx = (e.clientX - rect.left) * scale;
      mouse.ty = (rect.height - (e.clientY - rect.top)) * scale;
      mouse.ti = 1;
    });
    hero.addEventListener('pointerleave', function () { mouse.ti = 0; });

    var visible = true;
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);

    var start = performance.now();
    function frame(now) {
      if (visible && !document.hidden) {
        mouse.x = lerp(mouse.x, mouse.tx, 0.08);
        mouse.y = lerp(mouse.y, mouse.ty, 0.08);
        mouse.i = lerp(mouse.i, mouse.ti, 0.04);
        mouse.ti *= 0.985;
        gl.uniform2f(uR, W, H);
        gl.uniform1f(uT, (now - start) / 1000);
        gl.uniform2f(uM, mouse.x, mouse.y);
        gl.uniform1f(uMi, mouse.i);
        gl.drawArrays(gl.TRIANGLES, 0, 3);
      }
      if (!rm) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    if (!rm) {
      gsap.to('.uc2-hero__img', { yPercent: 18, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
      gsap.to('.uc2-hero__title', { yPercent: 30, opacity: 0.2, ease: 'none', scrollTrigger: { trigger: hero, start: 'top top', end: 'bottom top', scrub: true } });
    }
  })();

  /* ---------------------------------------------------------------- marquee */
  $$('[data-uc2-marquee]').forEach(function (track) {
    if (rm) return;
    var tween = gsap.to(track, { xPercent: -50, duration: 28, ease: 'none', repeat: -1 });
    var dir = 1;
    if (lenis) {
      lenis.on('scroll', function (l) {
        var vel = l.velocity || 0;
        if (vel !== 0) dir = vel > 0 ? 1 : -1;
        var boost = Math.min(Math.abs(vel) * 0.25, 5);
        gsap.to(tween, { timeScale: dir * (1 + boost), duration: 0.3, overwrite: true });
      });
    }
  });

  /* --------------------------------------------------------- titres & reveals */
  $$('[data-uc2-lines]').forEach(function (el) {
    var lines = splitLines(el);
    if (rm) return;
    gsap.from(lines, {
      yPercent: 105,
      duration: 1.3,
      ease: 'expo.out',
      stagger: 0.1,
      scrollTrigger: { trigger: el, start: 'top 85%' }
    });
  });

  $$('.uc2-reveal').forEach(function (el) {
    if (el.hasAttribute('data-uc2-hero-fade')) return;
    if (rm) { gsap.set(el, { opacity: 1, y: 0 }); return; }
    gsap.to(el, { opacity: 1, y: 0, duration: 1.2, ease: 'expo.out', scrollTrigger: { trigger: el, start: 'top 90%' } });
  });

  /* -------------------------------------------------------------- manifeste */
  $$('[data-uc2-words]').forEach(function (el) {
    el.innerHTML = el.innerHTML.replace(/§([^§]+)§/g, '<span class="is-blue">$1</span>');
    var words = [];
    (function walk(node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (part) {
            if (!part) return;
            if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(' ')); return; }
            var s = document.createElement('span');
            s.className = 'uc2-w';
            s.textContent = part;
            frag.appendChild(s);
            words.push(s);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.classList && n.classList.contains('uc2-pill')) {
          n.classList.add('uc2-w');
          words.push(n);
        } else if (n.nodeType === 1) {
          walk(n);
        }
      });
    })(el);
    if (rm) { words.forEach(function (w) { w.classList.add('is-on'); }); return; }
    ST.create({
      trigger: el,
      start: 'top 78%',
      end: 'bottom 45%',
      scrub: true,
      onUpdate: function (self) {
        var n = Math.round(self.progress * words.length);
        for (var i = 0; i < words.length; i++) words[i].classList.toggle('is-on', i < n);
      }
    });
  });

  /* --------------------------------------------------------------- terrains */
  $$('[data-uc2-terrains]').forEach(function (sec) {
    var pin = $('[data-uc2-pin]', sec);
    var track = $('[data-uc2-track]', sec);
    var bar = $('[data-uc2-progress]', sec);
    if (rm) return;
    var mm = gsap.matchMedia();
    mm.add('(min-width: 900px)', function () {
      var dist = function () { return Math.max(0, track.scrollWidth - window.innerWidth); };
      var tween = gsap.to(track, {
        x: function () { return -dist(); },
        ease: 'none',
        scrollTrigger: {
          trigger: pin,
          start: 'top top',
          end: function () { return '+=' + dist(); },
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
          onUpdate: function (self) { if (bar) bar.style.transform = 'scaleX(' + self.progress + ')'; }
        }
      });
      $$('.uc2-panel', track).forEach(function (panel) {
        var img = $('[data-uc2-parallax]', panel);
        if (img) {
          gsap.fromTo(img, { xPercent: 7 }, {
            xPercent: -7,
            ease: 'none',
            scrollTrigger: { trigger: panel, containerAnimation: tween, start: 'left right', end: 'right left', scrub: true }
          });
        }
        var media = $('.uc2-panel__media', panel);
        gsap.fromTo(media, { clipPath: 'inset(12% 0 12% 0)' }, {
          clipPath: 'inset(0% 0 0% 0)',
          ease: 'none',
          scrollTrigger: { trigger: panel, containerAnimation: tween, start: 'left 95%', end: 'left 35%', scrub: true }
        });
      });
    });
    mm.add('(max-width: 899px)', function () {
      $$('.uc2-panel__media', track).forEach(function (m) {
        gsap.fromTo(m, { clipPath: 'inset(10% 6% 10% 6%)' }, { clipPath: 'inset(0% 0% 0% 0%)', ease: 'none', scrollTrigger: { trigger: m, start: 'top 95%', end: 'top 40%', scrub: true } });
      });
    });
  });

  /* ------------------------------------------------------------------ gamme */
  $$('[data-uc2-gamme]').forEach(function (sec) {
    var float = $('[data-uc2-float]', sec);
    var imgs = float ? $$('.uc2-float__img', float) : [];
    var rows = $$('[data-uc2-row]', sec);
    if (!rm) {
      gsap.from(rows, { opacity: 0, y: 30, duration: 1, ease: 'expo.out', stagger: 0.05, scrollTrigger: { trigger: '.uc2-gamme__list', start: 'top 85%' } });
    }
    if (!float || !finePointer) return;
    var pos = { x: 0, y: 0, tx: 0, ty: 0 };
    var active = false;
    rows.forEach(function (row) {
      row.addEventListener('mouseenter', function () {
        var i = +row.dataset.uc2Row;
        imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
        float.classList.add('is-on');
        active = true;
      });
      row.addEventListener('mouseleave', function () { float.classList.remove('is-on'); active = false; });
    });
    window.addEventListener('mousemove', function (e) { pos.tx = e.clientX; pos.ty = e.clientY; });
    var fw = float.offsetWidth || 300;
    gsap.ticker.add(function () {
      if (!active && !float.classList.contains('is-on')) return;
      pos.x = lerp(pos.x || pos.tx, pos.tx, 0.14);
      pos.y = lerp(pos.y || pos.ty, pos.ty, 0.14);
      var rot = (pos.tx - pos.x) * 0.04;
      fw = float.offsetWidth;
      float.style.translate = (pos.x - fw / 2 + 60) + 'px ' + (pos.y - fw / 2) + 'px';
      float.style.rotate = Math.max(-12, Math.min(12, rot)) + 'deg';
    });
  });

  /* ---------------------------------------------------------------- panier */
  function setCount(n) { $$('[data-uc2-cart-count]').forEach(function (el) { el.textContent = n; }); }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-uc2-add]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +btn.dataset.uc2Add, quantity: 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        setCount(cart.item_count);
        btn.classList.add('is-done');
        btn.textContent = 'Ajouté ✓';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        var cartLink = $('[data-uc2-cart]');
        if (cartLink && !rm) gsap.fromTo(cartLink, { scale: 1.25 }, { scale: 1, duration: 0.8, ease: 'elastic.out(1, 0.4)' });
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; btn.disabled = false; }, 2400);
      })
      .catch(function () {
        btn.textContent = 'Indisponible';
        setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 2400);
      });
  });

  /* --------------------------------------------------------------- physique */
  $$('[data-uc2-phys]').forEach(function (sec) {
    var canvas = $('[data-uc2-scope]', sec);
    var freqEl = $('[data-uc2-freq]', sec);
    var stateEl = $('[data-uc2-scope-state]', sec);
    var steps = $$('[data-uc2-step]', sec);
    if (!canvas) return;
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W, H;
    function resize() {
      W = canvas.offsetWidth; H = canvas.offsetHeight;
      canvas.width = W * dpr; canvas.height = H * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    }
    resize();
    window.addEventListener('resize', resize);
    var cur = { amp: 0.05, freq: 6, noise: 0 };
    var tgt = { amp: 0.05, freq: 6, noise: 0 };

    function activate(step) {
      steps.forEach(function (s) { s.classList.toggle('is-active', s === step); });
      tgt.amp = (+step.dataset.amp || 0) / 100;
      tgt.freq = +step.dataset.freq || 6;
      tgt.noise = (+step.dataset.noise || 0) / 100;
      if (stateEl) stateEl.textContent = step.dataset.state || '';
    }
    if (steps[0]) activate(steps[0]);
    steps.forEach(function (step) {
      ST.create({ trigger: step, start: 'top 55%', end: 'bottom 55%', onToggle: function (self) { if (self.isActive) activate(step); } });
    });

    var visible = false;
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(canvas);
    var t = 0;
    function draw() {
      if (visible && !document.hidden) {
        t += 1 / 60;
        cur.amp = lerp(cur.amp, tgt.amp, 0.06);
        cur.freq = lerp(cur.freq, tgt.freq, 0.06);
        cur.noise = lerp(cur.noise, tgt.noise, 0.06);
        ctx.clearRect(0, 0, W, H);
        for (var pass = 0; pass < 2; pass++) {
          ctx.beginPath();
          for (var x = 0; x <= W; x += 2) {
            var u = x / W;
            var env = Math.sin(u * Math.PI);
            var y = Math.sin(u * cur.freq * 6.283 + t * 9) * 0.8 + Math.sin(u * cur.freq * 15.7 - t * 14) * 0.2;
            y += (Math.random() - 0.5) * cur.noise * 1.4;
            var py = H / 2 + y * cur.amp * H * 0.38 * env;
            if (x === 0) ctx.moveTo(x, py); else ctx.lineTo(x, py);
          }
          ctx.strokeStyle = pass ? '#e6ebff' : 'rgba(46,92,255,0.9)';
          ctx.lineWidth = pass ? 1.2 : 5;
          ctx.shadowBlur = pass ? 0 : 18;
          ctx.shadowColor = '#2e5cff';
          ctx.stroke();
        }
        if (freqEl) {
          var f = cur.amp < 0.08 ? 0 : 40 + (Math.random() - 0.5) * cur.noise * 0.6;
          freqEl.textContent = f === 0 ? '00.0' : f.toFixed(1);
        }
      }
      if (!rm) requestAnimationFrame(draw);
    }
    if (rm) { visible = true; cur = Object.assign({}, tgt, { amp: 0.6 }); }
    draw();
  });

  /* ------------------------------------------------------------ avant/après */
  $$('[data-uc2-compare]').forEach(function (cmp) {
    var input = $('input', cmp);
    var set = function (v) { cmp.style.setProperty('--pos', v + '%'); };
    input.addEventListener('input', function () { set(input.value); });
    if (rm) return;
    var o = { v: 50 };
    ST.create({
      trigger: cmp,
      start: 'top 70%',
      once: true,
      onEnter: function () {
        gsap.timeline()
          .to(o, { v: 82, duration: 1.1, ease: 'power3.inOut', onUpdate: function () { set(o.v); input.value = o.v; } })
          .to(o, { v: 22, duration: 1.3, ease: 'power3.inOut', onUpdate: function () { set(o.v); input.value = o.v; } })
          .to(o, { v: 50, duration: 1, ease: 'power3.inOut', onUpdate: function () { set(o.v); input.value = o.v; } });
      }
    });
  });

  /* ------------------------------------------------------------------- avis */
  $$('[data-uc2-avis]').forEach(function (sec) {
    var tabs = $$('[data-uc2-q-tab]', sec);
    var quotes = $$('[data-uc2-quote]', sec);
    if (!tabs.length) return;
    var idx = 0;
    var bar = null;
    function show(i) {
      var prev = quotes[idx];
      idx = i;
      tabs.forEach(function (t, k) {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
        gsap.set($('i', t), { scaleX: 0 });
      });
      quotes.forEach(function (q, k) { q.hidden = k !== i; });
      if (!rm) {
        if (prev && prev !== quotes[i]) gsap.set(prev, { clearProps: 'all' });
        gsap.fromTo(quotes[i], { opacity: 0, y: 40 }, { opacity: 1, y: 0, duration: 1, ease: 'expo.out' });
        if (bar) bar.kill();
        bar = gsap.to($('i', tabs[i]), { scaleX: 1, duration: 7, ease: 'none', onComplete: function () { show((idx + 1) % tabs.length); } });
        bar.pause();
        if (inView) bar.play();
      }
    }
    var inView = false;
    ST.create({ trigger: sec, start: 'top 70%', end: 'bottom 30%', onToggle: function (s) { inView = s.isActive; if (bar) (inView ? bar.play() : bar.pause()); } });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    show(0);
  });

  /* -------------------------------------------------------------------- faq */
  $$('[data-uc2-faq]').forEach(function (item) {
    var btn = $('button', item);
    btn.addEventListener('click', function () {
      var open = !item.classList.contains('is-open');
      item.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      setTimeout(function () { ST.refresh(); }, 650);
    });
  });

  /* --------------------------------------------------------------- closer */
  var closerTitle = $('.uc2-closer__title');
  if (closerTitle && !rm) {
    gsap.fromTo(closerTitle, { letterSpacing: '0.08em' }, { letterSpacing: '-0.01em', ease: 'none', scrollTrigger: { trigger: '.uc2-closer', start: 'top bottom', end: 'top 20%', scrub: true } });
  }

  /* ------------------------------------------------------------- magnétique */
  if (finePointer && !rm) {
    $$('[data-uc2-magnetic]').forEach(function (el) {
      var xTo = gsap.quickTo(el, 'x', { duration: 0.6, ease: 'power3' });
      var yTo = gsap.quickTo(el, 'y', { duration: 0.6, ease: 'power3' });
      el.addEventListener('mousemove', function (e) {
        var r = el.getBoundingClientRect();
        xTo((e.clientX - r.left - r.width / 2) * 0.35);
        yTo((e.clientY - r.top - r.height / 2) * 0.35);
      });
      el.addEventListener('mouseleave', function () { xTo(0); yTo(0); });
    });
  }

  /* ----------------------------------------------------------------- curseur */
  if (finePointer && !rm) {
    var cur = $('.uc2-cursor');
    if (cur) {
      html.classList.add('uc2-has-cursor');
      var dot = $('.uc2-cursor__dot', cur);
      var ring = $('.uc2-cursor__ring', cur);
      var txt = $('.uc2-cursor__txt', cur);
      var p = { x: -100, y: -100, rx: -100, ry: -100 };
      window.addEventListener('mousemove', function (e) { p.x = e.clientX; p.y = e.clientY; });
      gsap.ticker.add(function () {
        p.rx = lerp(p.rx, p.x, 0.18);
        p.ry = lerp(p.ry, p.y, 0.18);
        dot.style.transform = 'translate(' + p.x + 'px,' + p.y + 'px)';
        ring.style.transform = 'translate(' + p.rx + 'px,' + p.ry + 'px)';
      });
      document.addEventListener('mouseover', function (e) {
        var lab = e.target.closest('[data-uc2-cursor]');
        var link = e.target.closest('a, button, input[type="range"]');
        cur.classList.toggle('is-label', !!lab && !(link && link.matches('button')));
        cur.classList.toggle('is-link', !lab && !!link);
        if (lab) txt.textContent = lab.getAttribute('data-uc2-cursor');
      });
      document.addEventListener('mouseleave', function () { p.x = p.y = -100; });
    }
  }

  /* ---------------------------------------------------------------- nav */
  var nav = $('[data-uc2-nav]');
  if (nav) {
    var lastY = 0;
    var onScroll = function (y) {
      var down = y > lastY;
      nav.classList.toggle('is-hidden', down && y > window.innerHeight * 0.6);
      lastY = y;
    };
    if (lenis) lenis.on('scroll', function (l) { onScroll(l.scroll); });
    else window.addEventListener('scroll', function () { onScroll(window.scrollY); }, { passive: true });
  }

  var sheet = $('[data-uc2-sheet]');
  var menuBtn = $('[data-uc2-menu]');
  function closeSheet() {
    if (!sheet || !sheet.classList.contains('is-open')) return;
    sheet.classList.remove('is-open');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', 'false');
    if (lenis) lenis.start();
  }
  if (sheet && menuBtn) {
    menuBtn.addEventListener('click', function () {
      sheet.classList.add('is-open');
      menuBtn.setAttribute('aria-expanded', 'true');
      if (lenis) lenis.stop();
    });
    $('[data-uc2-menu-close]', sheet).addEventListener('click', closeSheet);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
  }

  window.addEventListener('load', function () { ST.refresh(); });
})();
